import { HITL, HttpSDK } from '@/api';
import { IAgent } from '@/types';
import { GET_USERS_PROJECTION } from './types';
import { UIEventBus, THROW_API_ERROR } from '@/common/ui-event-bus';

export const useGetAgents = () => {
  const PROJECTION_DELIMITER = ',';
  const USERS_PROJECTION = GET_USERS_PROJECTION.join(PROJECTION_DELIMITER);

  const getAPIAgent = async (args: {
    agentId: string;
    multiUserId?: string;
  }) => {
    const { agentId, multiUserId } = args;
    try {
      return await HITL.agents.getCompleteAgentById({
        agentId,
        multiUserId,
      }) as IAgent;
    } catch (error) {
      UIEventBus.$emit(THROW_API_ERROR, { error });
      throw error;
    }
  };

  const getAPIAgents = async () => {
    try {
      const responses = await HITL.agents.getCompleteAgents();
      return responses.data as IAgent[];
    } catch (error) {
      UIEventBus.$emit(THROW_API_ERROR, { error });
      throw error;
    }
  };

  /** TODO: API is not available for guest accounts! */
  const getAgentMultiUser = async (multiUserId: string) => {
    try {
      return await HttpSDK.multiusers.getProfileById(multiUserId);
    } catch (e) {
      console.warn(`Multi-User [${multiUserId}] is not available!`);
    }
  };

  /**
   * Get info about agents on current account.
   * TODO: API is not available for guest accounts!
   */
  const getUsers = async () => {
    const users: Partial<IAgent>[] = [];
    let offsetItemId = 0;
    let keepLoading = true;

    /**
     * TODO: Remove loading in chunks when we no longer use Dynamo DB
     * on the back end and can get all agents in one request.
     */
    while (keepLoading) {
      const query = offsetItemId
        ? { last: { id: offsetItemId }, projection: USERS_PROJECTION }
        : { projection: USERS_PROJECTION };
      const result = await HttpSDK.users.getUsers(query);

      /* API can auto-paginate response if there are too many items */
      result.length
        ? users.push(...result)
        : users.push(...result.items);
      offsetItemId = result.last?.id;
      keepLoading = !!result.last;
    }

    return users;
  };

  return { getAPIAgent, getAPIAgents, getUsers, getAgentMultiUser };
};
